<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.FLAME_DETECTOR">
  </app-configuration-wizard-back-button>

  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@flameDetectorConfiguration.wizard.step1">Substanz</odx-wizard-step>
    <odx-wizard-step i18n="@@flameDetectorConfiguration.wizard.step2">Familie</odx-wizard-step>
    <odx-wizard-step i18n="@@flameDetectorConfiguration.wizard.step3">Variante</odx-wizard-step>
    <odx-wizard-step i18n="@@flameDetectorConfiguration.wizard.step4">Zubehör</odx-wizard-step>
  </odx-wizard>

  <app-gas-selector
    class="w-100 h-100"
    [hidden]="activeStep !== 0 || (originalConfiguration && !isIncompleteConfiguration)"
    [project]="project"
    [originalGas]="originalConfiguration?.substance"
    [productType]="FgdsProductType.FLAME_DETECTOR"
    (gasSelect$)="selectSubstance($event)"
  ></app-gas-selector>

  <app-flame-detector-family-selector
    class="w-100 h-100"
    [hidden]="activeStep !== 1"
    [selectedSubstance]="selectedSubstance"
    [originalFlameDetector]="originalConfiguration?.family"
    (familySelect$)="selectFamily($event)"
  ></app-flame-detector-family-selector>

  @if (selectedFamily) {
    <app-flame-detector-variant-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 2"
      [selectedFamily]="selectedFamily"
      [selectedSubstance]="selectedSubstance"
      [showCosts]="project.showCostFlag"
      [originalVariant]="originalConfiguration?.variant"
      (variantSelect$)="selectVariant($event)"
    ></app-flame-detector-variant-selector>
  }

  @if (selectedVariant) {
    <app-attachment-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 3"
      [headerProducts]="[selectedSubstance!, selectedVariant!]"
      [products]="
        selectedVariant.id === originalConfiguration?.variant?.id
          ? { selectedProducts: [selectedVariant], preselectedAttachments: originalConfiguration!.attachments }
          : { selectedProducts: [selectedVariant] }
      "
      [showCosts]="project.showCostFlag"
      (attachmentsSelect$)="selectedAttachments = $event"
    ></app-attachment-selector>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="activeStep"
    [steps]="steps"
    [isPreviousButtonDisabled]="activeStep === 1 && originalConfiguration !== undefined && !isIncompleteConfiguration"
  ></app-product-config-stepper-bar>
</div>
